import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "pirogi_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [bumpKey, setBumpKey] = useState(0); // re-trigger animation

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch {}
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  /**
   * key = product.id + ":" + unit (so 1кг and 2кг line items don't collide)
   */
  const addItem = useCallback((product, qty, unit) => {
    setItems((prev) => {
      const key = `${product.id}:${unit}`;
      const existing = prev.find((it) => it.key === key);
      if (existing) {
        return prev.map((it) =>
          it.key === key ? { ...it, quantity: it.quantity + qty } : it,
        );
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          name: product.name,
          image_url: product.image_url,
          price: product.price,
          unit,
          quantity: qty,
        },
      ];
    });
    setBumpKey((k) => k + 1);
  }, []);

  const updateQty = useCallback((key, qty) => {
    setItems((prev) =>
      prev
        .map((it) => (it.key === key ? { ...it, quantity: qty } : it))
        .filter((it) => it.quantity > 0),
    );
  }, []);

  const removeItem = useCallback((key) => {
    setItems((prev) => prev.filter((it) => it.key !== key));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const itemsTotal = items.reduce(
    (sum, it) => sum + Math.round(it.price * it.quantity),
    0,
  );

  const count = items.reduce((sum, it) => sum + it.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        items,
        open,
        setOpen,
        addItem,
        updateQty,
        removeItem,
        clear,
        itemsTotal,
        count,
        bumpKey,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
